import { Component } from '@angular/core';
import { HomeCarousel } from '../../components/home/home-carousel/home-carousel';
import { HomeCategoies } from '../../components/home/home-categoies/home-categoies';
import { HomeStyle } from '../../components/home/home-style/home-style';
import { HomeWelcome } from '../../components/home/home-welcome/home-welcome';
import { HomeWhy } from '../../components/home/home-why/home-why';
import { TitleService } from '../../services/title.service';
@Component({
  selector: 'app-home-page',
  imports: [HomeCarousel, HomeWelcome, HomeCategoies, HomeStyle, HomeWhy],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss',
})
export class HomePage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('');
  }
}
